import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetDocumentImportHistory = ({
  integrationName,
}: {
  integrationName: string;
}) => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    documentImportHistory: {
      date: string;
      count: number;
    }[];
  }>(GET_DOCUMENT_IMPORT_HISTORY_QUERY, {
    variables: { tenantId, integrationName },
    skip: !tenantId,
  });

  return {
    history: data?.documentImportHistory || [],
    error,
    loading,
    refetch,
  };
};

export const GET_DOCUMENT_IMPORT_HISTORY_QUERY = gql`
  query GetDocumentImportHistory($tenantId: String!, $integrationName: String!) {
    documentImportHistory(tenantId: $tenantId, integrationName: $integrationName) {
      date
      count
    }
  }
`;
